// 1
import {getLocalStorageInfoMonitor} from './tools/LocalStorageHandler';
const {
    Environment,
    Network,
    RecordSource,
    Store,
} = require('relay-runtime')
// 2
const store = new Store(new RecordSource())
// 3
const network = Network.create((operation, variables) => {
    // 4
    let localStorageInfomonitor = getLocalStorageInfoMonitor();
    let setInfomonitorConfig = ''
    if(localStorageInfomonitor !== false){
      setInfomonitorConfig = '?ip='+localStorageInfomonitor.ip+'&token='+localStorageInfomonitor.token;
    }
    return fetch(window.config.API_END_POINT + setInfomonitorConfig, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: operation.text,
            variables,
        }),
    }).then(response => {
        if (!response.ok) {
            throw Error('Fetch response -> '+ response.statusText);
        }
        return response.json()
    })
});
// 5
const environment = new Environment({
    network,
    store,
});
// 6
export default environment



// WEBPACK FOOTER //
// ./src/Environment.js